import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box';

import { LISTING_PAGE_TABS_HEIGHT } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';
import { PREDICT_NAV_HEIGHT } from '@futrli/predict/hooks/useNavHeight';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { WorkspaceListView } from '@futrli/views/views/workspaces/WorkspaceListView/WorkspaceListView';

import { ConsolidationsActionsProvider } from '../../../context/consolidations-actions-context/consolidations-actions-context';
import { ConsolidationsList } from '../../../components/consolidations-list/consolidations-list';
import { ConsolidationsListFilterBar } from '../../../components/consolidations-list-filter-bar/consolidations-list-filter-bar';
import { useConsolidationsFilters } from '../../../hooks/use-consolidations-filters/use-consolidations-filters';

export const ConsolidationsTabContainer = () => {
  const flags = useFlags();
  const { workspaceId = '' } = useParams();

  const view = useApiView(useMemo(() => new WorkspaceListView(flags, workspaceId, true), [flags, workspaceId]));
  const { consolidations, isLoading } = view.state;

  const {
    searchTerm,
    onSearchChange,
    filteredConsolidations,
    onPresentationCurrencyFilterChange,
    presentationCurrencyFilterValue
  } = useConsolidationsFilters(consolidations || []);

  return (
    <ConsolidationsActionsProvider>
      <Box mt={1}>
        <ConsolidationsListFilterBar
          onSearchChange={onSearchChange}
          onPresentationCurrencyFilterChange={onPresentationCurrencyFilterChange}
          searchTerm={searchTerm}
          stickyTop={PREDICT_NAV_HEIGHT + LISTING_PAGE_TABS_HEIGHT}
          presentationCurrencyFilterValue={presentationCurrencyFilterValue}
          consolidations={consolidations || []}
        />
        <Box mt={3}>
          <ConsolidationsList consolidations={filteredConsolidations} isLoading={isLoading} />
        </Box>
      </Box>
    </ConsolidationsActionsProvider>
  );
};
